import { render } from "./CxSosButton.vue?vue&type=template&id=3042c3ae"
import script from "./CxSosButton.vue?vue&type=script&lang=js"
export * from "./CxSosButton.vue?vue&type=script&lang=js"

import "./CxSosButton.vue?vue&type=style&index=0&id=3042c3ae&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__